import React, { memo } from 'react';
import { Phone, Mail, MessageCircle, Twitter, Instagram, Hash, Linkedin } from 'lucide-react';
import XIcon from './icons/XIcon';
import { useTheme } from '../contexts/ThemeContext';
import { useSiteSettings } from '../contexts/SiteSettingsContext';

const InfoBar = () => {
  const { isDark } = useTheme();
  const { siteSettings } = useSiteSettings();

  return (
    <div className={`${isDark ? 'bg-slate-900' : 'bg-stone-50'} border-b ${isDark ? 'border-slate-800' : 'border-gray-200'} py-2`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between text-sm">
          {/* Left Side - Contact Info */}
          <div className="flex items-center gap-6">
            {/* Phone */}
            <div className="flex items-center gap-2">
              <Phone className={`w-4 h-4 ${isDark ? 'text-gray-400' : 'text-gray-600'}`} />
              <span className={`${isDark ? 'text-gray-300' : 'text-gray-700'}`}>{siteSettings.contact_phone}</span>
            </div>

            {/* Email */}
            <div className="flex items-center gap-2">
              <Mail className={`w-4 h-4 ${isDark ? 'text-gray-400' : 'text-gray-600'}`} />
              <span className={`${isDark ? 'text-gray-300' : 'text-gray-700'}`}>{siteSettings.contact_email}</span>
            </div>
          </div>

          {/* Right Side - Social Media */}
          <div className="flex items-center gap-4">
            {/* X (Twitter) */}
            {siteSettings.social_twitter && (
              <a
                href={siteSettings.social_twitter}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
                className={`w-8 h-8 ${isDark ? 'bg-gray-800 hover:bg-gray-700' : 'bg-gray-200 hover:bg-gray-300'} rounded-full flex items-center justify-center transition-colors duration-300 group`}
              >
                <XIcon className={`w-4 h-4 ${isDark ? 'text-white' : 'text-gray-700'} group-hover:scale-110 transition-transform duration-300`} />
              </a>
            )}

            {/* Instagram */}
            {siteSettings.social_instagram && (
              <a
                href={siteSettings.social_instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className={`w-8 h-8 ${isDark ? 'bg-gray-800 hover:bg-gray-700' : 'bg-gray-200 hover:bg-gray-300'} rounded-full flex items-center justify-center transition-colors duration-300 group`}
              >
                <Instagram className={`w-4 h-4 ${isDark ? 'text-white' : 'text-gray-700'} group-hover:scale-110 transition-transform duration-300`} />
              </a>
            )}

            {/* LinkedIn */}
            {siteSettings.social_linkedin && (
              <a
                href={siteSettings.social_linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className={`w-8 h-8 ${isDark ? 'bg-gray-800 hover:bg-gray-700' : 'bg-gray-200 hover:bg-gray-300'} rounded-full flex items-center justify-center transition-colors duration-300 group`}
              >
                <Linkedin className={`w-4 h-4 ${isDark ? 'text-white' : 'text-gray-700'} group-hover:scale-110 transition-transform duration-300`} />
              </a>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(InfoBar);

